/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AdOperatorAvailabilityQueryVariables = Types.Exact<{
  regionId: Types.Scalars['ID']['input']
}>

export type AdOperatorAvailabilityQuery = {
  __typename?: 'Query'
  fccOperatorAvailability: {
    __typename?: 'FccCurrentOperatorAvailability'
    availability: Types.FccOperatorAvailabilityType
  } | null
}

export type SetAdOperatorAvailabilityMutationVariables = Types.Exact<{
  availability: Types.FccOperatorAvailabilityType
  regionId: Types.Scalars['ID']['input']
}>

export type SetAdOperatorAvailabilityMutation = {
  __typename?: 'Mutation'
  fccSetAvailability: {
    __typename?: 'FccCurrentOperatorAvailability'
    availability: Types.FccOperatorAvailabilityType
  }
}

export const AdOperatorAvailabilityDocument = gql`
    query AdOperatorAvailability($regionId: ID!) {
  fccOperatorAvailability(regionId: $regionId) {
    availability
  }
}
    `

/**
 * __useAdOperatorAvailabilityQuery__
 *
 * To run a query within a React component, call `useAdOperatorAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdOperatorAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdOperatorAvailabilityQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useAdOperatorAvailabilityQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdOperatorAvailabilityQuery,
    AdOperatorAvailabilityQueryVariables
  > &
    (
      | { variables: AdOperatorAvailabilityQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdOperatorAvailabilityQuery,
    AdOperatorAvailabilityQueryVariables
  >(AdOperatorAvailabilityDocument, options)
}
export function useAdOperatorAvailabilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdOperatorAvailabilityQuery,
    AdOperatorAvailabilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdOperatorAvailabilityQuery,
    AdOperatorAvailabilityQueryVariables
  >(AdOperatorAvailabilityDocument, options)
}
// @ts-ignore
export function useAdOperatorAvailabilitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdOperatorAvailabilityQuery,
    AdOperatorAvailabilityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdOperatorAvailabilityQuery,
  AdOperatorAvailabilityQueryVariables
>
export function useAdOperatorAvailabilitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdOperatorAvailabilityQuery,
        AdOperatorAvailabilityQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdOperatorAvailabilityQuery | undefined,
  AdOperatorAvailabilityQueryVariables
>
export function useAdOperatorAvailabilitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdOperatorAvailabilityQuery,
        AdOperatorAvailabilityQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AdOperatorAvailabilityQuery,
    AdOperatorAvailabilityQueryVariables
  >(AdOperatorAvailabilityDocument, options)
}
export type AdOperatorAvailabilityQueryHookResult = ReturnType<
  typeof useAdOperatorAvailabilityQuery
>
export type AdOperatorAvailabilityLazyQueryHookResult = ReturnType<
  typeof useAdOperatorAvailabilityLazyQuery
>
export type AdOperatorAvailabilitySuspenseQueryHookResult = ReturnType<
  typeof useAdOperatorAvailabilitySuspenseQuery
>
export type AdOperatorAvailabilityQueryResult = Apollo.QueryResult<
  AdOperatorAvailabilityQuery,
  AdOperatorAvailabilityQueryVariables
>
export const SetAdOperatorAvailabilityDocument = gql`
    mutation SetAdOperatorAvailability($availability: FccOperatorAvailabilityType!, $regionId: ID!) {
  fccSetAvailability(input: {availability: $availability, regionId: $regionId}) {
    availability
  }
}
    `
export type SetAdOperatorAvailabilityMutationFn = Apollo.MutationFunction<
  SetAdOperatorAvailabilityMutation,
  SetAdOperatorAvailabilityMutationVariables
>

/**
 * __useSetAdOperatorAvailabilityMutation__
 *
 * To run a mutation, you first call `useSetAdOperatorAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAdOperatorAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAdOperatorAvailabilityMutation, { data, loading, error }] = useSetAdOperatorAvailabilityMutation({
 *   variables: {
 *      availability: // value for 'availability'
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useSetAdOperatorAvailabilityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAdOperatorAvailabilityMutation,
    SetAdOperatorAvailabilityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SetAdOperatorAvailabilityMutation,
    SetAdOperatorAvailabilityMutationVariables
  >(SetAdOperatorAvailabilityDocument, options)
}
export type SetAdOperatorAvailabilityMutationHookResult = ReturnType<
  typeof useSetAdOperatorAvailabilityMutation
>
export type SetAdOperatorAvailabilityMutationResult =
  Apollo.MutationResult<SetAdOperatorAvailabilityMutation>
export type SetAdOperatorAvailabilityMutationOptions =
  Apollo.BaseMutationOptions<
    SetAdOperatorAvailabilityMutation,
    SetAdOperatorAvailabilityMutationVariables
  >
